import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Paper, Grid, Typography, Card, CardContent, Button, Stack, Box, Dialog } from '@mui/material';
import axios from '../../axiosInstance';
import FlipbookModal from '../../components/FlipbookModal';
import defaultThumbnail from '../../assets/logo4.png';
import { styled } from '@mui/system';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import Input from '../../components/ui/Input';

// ArticleDetails_Self.js
const ArticleDetails_Self = ({ onSearch, initialQuery }) => {
  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  const location = useLocation();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [chapters, setChapters] = useState([]);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  const [notificationOpen, setNotificationOpen] = useState(false);

  
  const { id: bookId } = useParams();

  const [item, setItem] = useState(null);
  const [recommendedBooks, setRecommendedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookDetails = async () => {
      if (!bookId) return;
      setLoading(true);
      try {
        const response = await axios.get(`https://backend.scholarkart.in/api/books/${bookId}`);
        const book = response.data;
    
        setItem({
          id: book._id,
          title: book.bookTitle || 'No title available',
          authors: book.authorName || 'Unknown',
          year: book.publicationYear || 'Unknown',
          type: book.bookType || 'Unknown',
          ISBN: book.ISBN || 'Unknown',
          publisher: book.publisherName || 'Unknown',
          course: book.courseDetails?.courseId?.courseName || 'Unknown',
          subject: book.courseDetails?.subjectId?.subjectName || 'Unknown',
          semester: book.courseDetails?.semester || 'Unknown',
          thumbnail: book.coverImageURL || defaultThumbnail,
          abstract: book.bookDescription || 'No description available',
          detailLink: book.pdfURL || '#',
        });
    
        // ✅ Fetch chapter info
        const chapterRes = await axios.get(`https://backend.scholarkart.in/api/bookchapters?bookId=${bookId}`);
        setChapters(chapterRes.data || []);
      } catch (err) {
        setError('Failed to fetch book details.');
      } finally {
        setLoading(false);
      }
    };
    fetchBookDetails();
  }, [bookId]);

    
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setUsername(user.username);  // Set username if user is logged in
        setCourseIds(user.courseIds);
        setCollegeId(user.collegeId);
        setDisplayname(user.displayname);
      }
    }, []);
  
  
    // Function to handle the search action
    const handleSearch = () => {
      const query = (inputValue || "").trim();
    
      if (!query) {
        alert("Please enter a search term.");
        return;
      }
  
      const user = JSON.parse(localStorage.getItem("user"));
      const hasCollege = user && user.collegeId;
    
      const targetPath = hasCollege
        ? `/mylibrary?query=${encodeURIComponent(query)}`
        : `/ebrarycollection?query=${encodeURIComponent(query)}`;
    
      navigate(targetPath, { state: { query } });
  
    };

      useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
          setUsername(user.username);  // Set username if user is logged in
          setCourseIds(user.courseIds);
          setDisplayname(user.displayname);
        }
      }, []);


    const handleClear = () => {
      setInputValue('');
    };

    if (loading) return <Typography>Loading...</Typography>;
    if (error) return <Typography>{error}</Typography>;

    const handleReadFullBook = (book) => {
      const user = JSON.parse(localStorage.getItem('user'));
      const token = localStorage.getItem('token');
    
      if (user && token) {
        axios.post('https://backend.scholarkart.in/api/bookaccesslog', {
          userId: user._id,
          collegeId: user.collegeId,
          bookId: book.id // or book._id if available
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
          console.log('✅ Full book access logged:', res.data);
        }).catch((error) => {
          console.error('Error logging full book access:', error);
        });
      }
    
      setPdfUrl(book.detailLink);
    };

    
    const handleReadChapter = (chapter) => {
      const user = JSON.parse(localStorage.getItem('user'));
      const token = localStorage.getItem('token');
    
      if (user && token) {
        axios.post('https://backend.scholarkart.in/api/bookaccesslog', {
          userId: user._id,
          collegeId: user.collegeId,
          bookId: chapter.bookId,
          chapterId: chapter._id
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
          console.log('✅ Chapter access logged:', res.data);
        }).catch((error) => {
          console.error('Error logging chapter access:', error);
        });
      }
    
      setPdfUrl(chapter.pdfURL);
    };
    

  return (
    <main className="flex-grow p-1">


    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">
        <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

          <div className="relative w-full max-w-lg">
                          <Input
                            placeholder="Search my library content..."
                            className="pl-10"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') handleSearch();
                            }}
                          />
            <FaSearch className="absolute left-3 top-3 text-gray-500" />
            {inputValue && (
              <button
                onClick={handleClear}
                className="absolute right-3 top-2 text-gray-500 hover:text-gray-700"
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>

          <div className="flex items-center space-x-4 relative">
            <Notification />
            <Profile />
          </div>
        </div>
        <br />
        <Box
          className="main-content"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' }, // column on mobile, row on desktop
          }}
        >
        <Grid container spacing={4}>
          {/* LEFT: Book Info */}
          <Grid item xs={12} md={5}>
            <Card sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
              <Box display="flex" flexDirection="column" alignItems="center">
              <Typography variant="h5" mt={2} fontWeight="bold" color="primary">{item.title}</Typography>
              <Typography variant="body2" color="text.secondary">{item.authors}</Typography>
              <Box
                sx={{
                  width: '100%',
                  maxWidth: 200,
                  overflow: 'hidden',
                  borderRadius: 2,
                  cursor: 'zoom-in',
                  '& img': {
                    transition: 'transform 0.3s ease-in-out',
                  },
                  '&:hover img': {
                    transform: 'scale(1.25)'
                  }
                }}
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  style={{ width: '100%', display: 'block' }}
                />
              </Box>

              </Box>

              <Box mt={2}>
                <Typography><strong>Book Type:</strong> {item.type}</Typography>
                <Typography><strong>Publisher:</strong> {item.publisher}</Typography>
                <Typography><strong>Year:</strong> {item.year}</Typography>
                <Typography><strong>ISBN:</strong> {item.ISBN}</Typography>
                <Typography><strong>Course:</strong> {item.course}</Typography>
                <Typography><strong>Semester:</strong> {item.semester}</Typography>
                <Typography><strong>Subject:</strong> {item.subject}</Typography>
                <Typography sx={{ color: 'primary.main' }}><strong>Description:</strong> {item.abstract}</Typography>
              </Box>

              <Button
                fullWidth
                variant="contained"
                color="warning"
                sx={{ mt: 3, fontWeight: 'bold' }}
                onClick={() => handleReadFullBook(item)}
              >
                📘 Read Complete Book
              </Button>

              
                          {/* Flipbook Modal for PDF */}
                          {pdfUrl && (
                        <Dialog
                          open={Boolean(pdfUrl)}
                          onClose={() => setPdfUrl(null)}
                          maxWidth="lg"
                          fullWidth
                        >
                          <FlipbookModal
                            pdfUrl={pdfUrl}
                            onClose={() => setPdfUrl(null)} 
                          />
                        </Dialog>
                      )}
            </Card>
          </Grid>

  {/* RIGHT: Chapter List */}
  <Grid item xs={12} md={7}>
    <Box>
      <Typography variant="h6" color="primary" fontWeight="bold" mb={2}>
        📚 Chapter-wise Reading
      </Typography>

      <Stack spacing={2}>
        {chapters.map((chapter, index) => (
          <Card
            key={index}
            sx={{
              p: 2,
              borderRadius: 2,
              boxShadow: 1,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Typography fontSize="14px">
              <strong>Chapter {chapter.chapterNumber}:</strong> {chapter.chapterTitle}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ width: 100 }}
              onClick={() => handleReadChapter(chapter)}
            >
              📖 Read
            </Button>


          </Card>
        ))}
      </Stack>
    </Box>
  </Grid>
</Grid>

</Box>

          </div>
          </div>
          </main>
  );
};

export default ArticleDetails_Self;

